<template>
  <ValidationObserver
    ref="entryItemObserver"
    v-slot="{ errors }">
    <SectionBox
      v-show="canEdit || hasName"
      class="mandala-evaluation-form__entry-item pb-0">
      <div class="d-flex justify-content-between align-items-center">
        <LabelText :label-for="name">
          {{ name }}
        </LabelText>
        <div class="mandala-evaluation-form__entry-item__score-info">
          合計スコア {{ sumScore }} / {{ maxScore }}
        </div>
      </div>
      <InputContainer class="mb-2">
        <template #prepend>
          <ChangedBox
            :active="hasNameChanged" />
        </template>
        <BaseTextFieldWithProvider
          v-if="canEdit"
          v-model="_value.name"
          field-class="pl-4 font-weight-bold"
          :name="`項目名 - ${displayOrder + 1}`"
          placeholder="項目を入力してください"
          empty-str-to-null
          :response-errors="responseErrors"
          :disabled="hasTemplateEntryName"
          style="color: #000;"
          vid="name" />
        <DisplayFormField
          v-else
          font-size="nm"
          bold>
          {{ _value.name }}
        </DisplayFormField>
      </InputContainer>
      <slot />
      <template v-if="canShowActivityRecords">
        <template v-if="canEdit">
          <LabelText label-for="活動記録">
            活動記録
          </LabelText>
          <BaseTextareaWithProvider
            v-model="_value.activityRecord"
            name="活動記録"
            :rows="3"
            :response-errors="responseErrors"
            vid="activityRecord" />
        </template>
        <template v-else-if="hasActivityRecord">
          <LabelText label-for="活動記録">
            活動記録
          </LabelText>
          <!-- eslint-disable -->
      <DisplayTextarea v-html="sanitizedLink(_value.activityRecord)" />
      <!-- eslint-enable -->
        </template>
        <template v-if="attachmentOption">
          <template v-if="canEdit">
            <LabelText label-for="ファイル">
              ファイルを添付
            </LabelText>
            <FileUploaderWithProvider
              v-model="_value.file"
              vid="file"
              name="ファイル"
              :response-errors="responseErrors" />
          </template>
          <template v-else-if="hasFile">
            <LabelText>ファイルを添付</LabelText>
            <FileViewer
              v-if="_value.file"
              :file="_value.file"
              :thumbnail="_value.thumbnail" />
          </template>
        </template>
      </template>
    </SectionBox>
  </ValidationObserver>
</template>

<script>
import SectionBox from '@/components/parts/SectionBox.vue'
import BaseTextFieldWithProvider from '@/components/parts/BaseTextFieldWithProvider.vue'
import BaseTextareaWithProvider from '@/components/parts/BaseTextareaWithProvider.vue'
import FileUploaderWithProvider from '@/components/parts/FileUploaderWithProvider.vue'
import LabelText from '@/components/parts/LabelText.vue'
import FileViewer from '@/components/parts/FileViewer.vue'
import ChangedBox from '@/components/parts/ChangedBox.vue'
import InputContainer from '@/components/parts/InputContainer.vue'
import DisplayFormField from '@/components/view/mandala_evaluation/DisplayFormField.vue'
import DisplayTextarea from '@/components/view/mandala_evaluation/DisplayTextarea.vue'
import sanitizedLinkMixin from '@/components/mixin/sanitizedLink'
import { mapGetters } from 'vuex'

export default {
  name: 'MandalaEvaluationFormEntryItem',
  components: {
    SectionBox,
    BaseTextFieldWithProvider,
    BaseTextareaWithProvider,
    LabelText,
    FileUploaderWithProvider,
    FileViewer,
    ChangedBox,
    InputContainer,
    DisplayFormField,
    DisplayTextarea
  },
  mixins: [sanitizedLinkMixin],
  props: {
    value: {
      type: Object,
      required: true
    },
    selectedMandalaGoalTemplate: {
      type: Object,
      required: true
    },
    displayOrder: {
      type: Number,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    isMine: {
      type: Boolean,
      default: false
    },
    lastMonthEntry: {
      type: Object,
      default: null
    },
    templateEntry: {
      type: Object,
      required: true
    },
    responseErrors: {
      type: Object,
      default: () => {}
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('auth', ['isManager']),
    ...mapGetters('tenant', ['attachmentOption']),
    _value: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    name() {
      return `項目名 - ${this.displayOrder + 1}`
    },
    hasTemplateEntryName() {
      return !!this.templateEntry.name
    },
    sumScore() {
      return this._value.actionGoals.reduce((prev, curr) => {
        return prev + (curr.score || 0)
      }, 0)
    },
    maxScore() {
      return this._value.actionGoals.length * 5
    },
    hasName() {
      return !!this._value.name
    },
    hasFile() {
      return !!this._value.file
    },
    hasActivityRecord() {
      return !!this._value.activityRecord
    },
    hasNameChanged() {
      if (!this.lastMonthEntry) {
        return false
      }
      return (this.lastMonthEntry.name || '') !== (this._value.name || '')
    },
    /**
     * @description 活動記録を閲覧できるのは
     * - テンプレートでロックされていない
     * - 本人
     * - 管理者
     * のいずれかの場合のみ
     */
    canShowActivityRecords() {
      return !this.isLockActivityRecords || this.isMine || this.isManager
    },
    isLockEntryNames() {
      return this.selectedMandalaGoalTemplate.isLockEntryNames
    },
    isLockActivityRecords() {
      return this.selectedMandalaGoalTemplate.isLockActivityRecords
    }
  },
  watch: {
    // 編集しようとした際にテンプレート側に項目名が設定されていたらその項目名で上書きする
    canEdit: {
      immediate: true,
      handler(val) {
        if (val && this.hasTemplateEntryName) {
          this._value.name = this.templateEntry.name
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mandala-evaluation-form__entry-item {
  &__score-info {
    color: $grey05;
    font-size: $fs-m;
    font-weight: bold;
  }
}

</style>